import { Injectable } from '@angular/core';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { Firestore, doc, setDoc } from '@angular/fire/firestore';
import { NgxImageCompressService } from 'ngx-image-compress';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(
    private storage: Storage,
    private firestore: Firestore,
    private imageCompress: NgxImageCompressService
  ) { }

  async uploadToFirebase(file: string, fileName: string): Promise<string> {
    // Compress the image before uploading
    const compressedImage = await this.compressImage(file);

    // Create Blob from compressed base64
    const base64Data = compressedImage.replace(/^data:image\/jpeg;base64,/, '');
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const uploadFile = new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' });

    const mainShop = sessionStorage.getItem('main') === 'true';
    const addShopExtension = mainShop ? '/DEU' : '';
    // Create reference and upload the Blob
    const fileRef = ref(this.storage, `GulliDesigns/CustomOrders${addShopExtension}/${fileName}.jpeg`);
    await uploadBytes(fileRef, uploadFile);
    return getDownloadURL(fileRef);
  }

  private async compressImage(imageDataUrl: string): Promise<string> {
    const img = await this.loadImage(imageDataUrl);
    let quality = 70;
    let ratio = 70;
    let compressedSizeInKB: number;
    let compressedImage: string;

    do {
      compressedImage = await this.imageCompress.compressFile(
        imageDataUrl,
        -1,  // orientation
        ratio,
        quality,
        img.width,
        img.height
      );
      compressedSizeInKB = this.getFileSizeInKB(compressedImage);

      if (compressedSizeInKB > 300) {
        quality -= 10;
      }
    } while (compressedSizeInKB > 300 && quality > 0);

    return compressedImage;
  }

  private loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  private getFileSizeInKB(base64String: string): number {
    const base64Length = base64String.length - (base64String.indexOf(',') + 1);
    const sizeInBytes = (base64Length * 3) / 4;
    return sizeInBytes / 1024;
  }

  magnetDesignDocument(url: string, location: any) {
    const mainShop = sessionStorage.getItem('main') === 'true';
    const addShopExtension = mainShop ? '' : 'DEU_';
    const docName = `Cst_${addShopExtension}${Math.random().toString(36).substring(2, 12)}`;
    const magnetDesignRef = doc(this.firestore, 'MagnetDesigns', docName);
    setDoc(magnetDesignRef, {
      magnetImage: {
        imageUrl: url,
        date: new Date(),
        location: {
          city: location?.city || 'Skopje',
          country: location?.country || 'Macedonia',
          latitude: location?.latitude || 41.99586407946381,
          longitude: location?.longitude || 21.431260572129624,
          countryISO: location?.countryISO || 'MKD',
          place: location?.place || 'Skopje',
        },
        locationType: 0,
        size: {
          height: 212,
          width: 334
        },
        type: 0
      }
    });
    return docName;
  }

  storyDocument() {
    const docName = this.generateRandomId();
    const storyDesignRef = doc(this.firestore, 'Stories', docName);
    setDoc(storyDesignRef, {});
    return docName;
  }


  generateRandomId(): string {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const bytes = crypto.getRandomValues(new Uint8Array(18));
    return Array.from(bytes)
      .map(b => chars[b % chars.length])
      .join('');
  }

}
